export function Round(value) {
    return Math.round(value * 100) / 100;
}



// WEBPACK FOOTER //
// ./src/functions/Maths.js